import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons"
import {
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

function SocialIcons(props) {
    const {color, linkedinURL, twitterURL, githubURL, websiteURL, showSocial} = props;
    const hasAnySocialLink = linkedinURL || twitterURL || githubURL || websiteURL;
    return (
        
        <div className='mb-4'>
            {
                showSocial && hasAnySocialLink ? <>
                    <h6 className="display-9"> SOCIAL </h6>
                    <p className="social">
                        {linkedinURL ? <><small><FontAwesomeIcon icon={faLinkedin} color={color} />{' '}{linkedinURL}</small></> : null}
                        {twitterURL ? <> {' '} <br />
                        <small><FontAwesomeIcon icon={faTwitter} color={color} />{' '}{twitterURL}</small></> : null}
                        {githubURL ? <> {' '} <br />
                        <small><FontAwesomeIcon icon={faGithub} color={color} />{' '}{githubURL}</small></> : null}
                        {websiteURL ? <> {' '} <br />
                        <small><FontAwesomeIcon icon={faGlobe} color={color} />{' '}{websiteURL}</small></> : null}
                    </p>
                </> : null
            }
            
        </div>
    );
}

export default SocialIcons;